/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFastForwardAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17.6 21H2V3h15.6l5.6 9zm-3.8-2h2.6l4.4-7-4.4-7h-2.6l4.4 7zm-6 0h3.6l4.4-7-4.4-7H7.8l4.4 7zM4 19h1.4l4.4-7-4.4-7H4z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgFastForwardAlt as FastForwardAlt };
